module.exports = __webpack_public_path__ + "static/media/decision.5f8ec3fc.png";